import styles from "../../styles/_ui/spinner.module.scss";

const Spinner = () => (
  <img src="/assets/images/spinner.png" alt="spinner" className={styles.spinner} />
);

export default Spinner;
